module.exports = __webpack_public_path__ + "img/電気回路_1_3.5d171d70.png";